import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Bubble from "../module-common/Bubble";
import moment from "moment";
import { ErrorOutlineOutlined, Pending, MoreHoriz } from "@mui/icons-material";

export default class ContentBubble extends Component {
  static propTypes = {
    content: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    fromAgent: PropTypes.bool,
    timestamp: PropTypes.instanceOf(moment),
    isAgent: PropTypes.bool,
    showTimestamp: PropTypes.bool,
    isError: PropTypes.bool
  };

  render() {
    const { content, timestamp, fromAgent, showTimestamp, mediaList, isError, isPending, onErrorClick } = this.props;
    return (
      <ContentSec>
        <Padding isAgent={fromAgent}>
          <Bubble
            isAgent={fromAgent}
            content={content}
            timestamp={timestamp}
            showTimestamp={showTimestamp}
            mediaList={mediaList}
          />
          <Toolbox>
            {isPending && <MoreHoriz />}
            {isError && <ErrorInfo>
              <div style={{ marginRight : 10 }}>
              <ErrorOutlineOutlined 
                onClick={e => {
                  if(onErrorClick) onErrorClick(e)
                }} 
              />  
              </div>
              <div>
              Tap to retry
              </div>
            </ErrorInfo>}
          </Toolbox>
        </Padding>
      </ContentSec>
    );
  }
}

const ErrorInfo = styled.div`
  text-align: right;
  width: 100%;
  font-size: 10px;
  padding-right: 20px;
`

const ContentSec = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  align-items: center;
`;

const Padding = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: ${props => (props.isAgent ? "row" : "row-reverse")};
  align-self: center;
`;

const Toolbox = styled.div`
  display: block;
  padding-top: 15px;
  height: 100%;
`
